/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUpdateCompanyRequestFromJSON(json) {
    return StreemApiUpdateCompanyRequestFromJSONTyped(json, false);
}
export function StreemApiUpdateCompanyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'parentCompanySid': !exists(json, 'parent_company_sid') ? undefined : json['parent_company_sid'],
        'subCompanyLimit': !exists(json, 'sub_company_limit') ? undefined : json['sub_company_limit'],
    };
}
export function StreemApiUpdateCompanyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'active': value.active,
        'parent_company_sid': value.parentCompanySid,
        'sub_company_limit': value.subCompanyLimit,
    };
}
//# sourceMappingURL=StreemApiUpdateCompanyRequest.js.map